// Labels Jira partagés par tous les projets pour distinguer correctif / évolutif (maintenance évolutive).
// Labels Jira. Les tags correctif/évolutif ne servent qu'à ARBITRER sur une maintenance évolutive
// (qui contient les deux). Sur une maintenance corrective seule, aucun tag n'est nécessaire :
// tout le temps est du correctif, sauf celui taggé non_facturable.
export const LABEL_CORRECTIVE = 'maint_corrective';
export const LABEL_EVOLUTIVE = 'maint_evolutive';
export const LABEL_NON_BILLABLE = 'non_facturable';
// Lien direct vers un ticket/epic Jira (ouvre dans un nouvel onglet).
export const JIRA_BROWSE_URL = 'https://up-time.atlassian.net/browse/';
